import { memo, useMemo } from "react";

import type { ReservationDetailForManagementReservationItemQuery } from "@/lib/gql/__generated__/graphql";

import { SearchResultTableToolTip } from "@/components/features/management/reservation/search/_shared/components/search-result-table/tool-tip";

import HelpIcon from "@/components/ui/icon/help";
import { Table } from "@/components/ui/table/table";

import { TableTBody } from "../../components/related-past-reservations-table/t-body";
import { TableTHeader } from "../../components/related-past-reservations-table/t-header";

type Props = {
	repeaterReservations: ReservationDetailForManagementReservationItemQuery["repeaterReservationList"];
	onClickReservation: (hotelID: string, reservationID: string) => void;
};

export const RelatedPastReservationsOfBasicInfoCompositions = memo(
	({ repeaterReservations, onClickReservation }: Props) => {
		/**
		 * 過去予約の予約があるかどうか
		 */
		const isShowRepeaterReservations = useMemo(() => repeaterReservations.length > 0, [repeaterReservations]);

		return (
			<div className="space-y-4">
				<div className="flex items-center gap-2">
					<h3 className="text-lg font-semibold">予約履歴</h3>
					<SearchResultTableToolTip
						label={<HelpIcon className="size-[18px]" />}
						tooltipText="同じメールアドレスで行われた予約を表示します"
					/>
				</div>
				{isShowRepeaterReservations ? (
					<div className="max-h-96 overflow-y-auto rounded-lg border shadow-sm">
						<Table className="w-full">
							{/* ヘッダー */}
							<TableTHeader />
							{/* 行 */}
							{repeaterReservations.map((reservation) => (
								<TableTBody
									key={reservation.id}
									reservation={reservation}
									onClickReservation={() =>
										onClickReservation(reservation.hotelID, reservation.reservationID)
									}
								/>
							))}
						</Table>
					</div>
				) : (
					<p className="text-gray-500">予約履歴はありません</p>
				)}
			</div>
		);
	},
);

RelatedPastReservationsOfBasicInfoCompositions.displayName = "RelatedPastReservationsOfBasicInfoCompositions";
